module.exports = __webpack_public_path__ + "static/media/bannerNew3.9b7e3eac.jpg";